// Shared bits for the small runner step renderers (Jun 2026 · the nine former "Coming soon" steps).
import React from 'react';
import axios from 'axios';

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('access_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function readKey(data, key) {
  if (!data || !key) return undefined;
  if (Object.prototype.hasOwnProperty.call(data, key)) return data[key];
  return key.split('.').reduce((v, p) => (v == null || typeof v !== 'object' ? undefined : v[p]), data);
}

export const humanise = (s) => String(s || '').replace(/[_.]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Seeded letter / PDF keys → the report that actually exists today.
const STATUS_LETTERS = new Set(['appraisal_booked', 'appraisal_confirmation', 'appraiser_booking', 'client_time_change_notice', 'quote_sent',
  'accepted_deposit_received', 'accepted_no_deposit_required', 'accepted_awaiting_deposit', 'quote_declined', 'height_safety_quote_request',
  'height_safety_confirm', 'work_starting_confirmation', 'work_complete_qi_booked', 'owner_completion_letter', 'invoiced_letter',
  'quality_questionnaire', 'payment_overdue_reminder', 'overdue_contact_summary', 'overdue_warning_letter', 'payment_plan_confirmation',
  'tribunal_evidence_bundle', 'paid']);
const ALIASES = { final_confirmation_letter: 'accepted_deposit_received', accepted_confirmation: 'accepted_deposit_received', payment_thanks_letter: 'paid', invoice_letter: 'invoiced_letter', quotation_letter: 'quote_sent' };

export function pdfUrlFor(key, capturedData) {
  const appraisalId = capturedData?.appraisal_id;
  const clientId = capturedData?.client_id || capturedData?.appraisal?.client_id;
  const k = ALIASES[key] || key;
  let route = '';
  if (k === 'warranty_certificate') route = appraisalId ? `/reports/certificate-of-completion/${appraisalId}?inline=true` : '';
  else if (k === 'final_statement') route = clientId ? `/reports/client-statement?client_id=${clientId}&inline=true` : '';
  else if (STATUS_LETTERS.has(k)) route = appraisalId ? `/reports/status-letter/${k}/${appraisalId}` : '';
  if (!route) return '';
  const tok = localStorage.getItem('access_token');
  const sep = route.includes('?') ? '&' : '?';
  return `${process.env.REACT_APP_BACKEND_URL || ''}/api${route}${sep}_bust=${Date.now()}`;
}

export async function writeback(capturedData, field, value, mergeKey) {
  const appraisal_id = capturedData?.appraisal_id;
  if (!appraisal_id) return null;
  const { data } = await api.post('/workflow/side-effects/field-writeback', { appraisal_id, field, value, merge_key: mergeKey || '' });
  return data;
}

export function StepCard({ icon: Icon, title, testid, children }) {
  return (
    <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm space-y-4 mb-6" data-testid={testid}>
      <div className="flex items-center gap-2 text-slate-800">
        {Icon && <Icon className="w-5 h-5 text-sky-700" />}
        <h3 className="font-semibold">{title}</h3>
      </div>
      {children}
    </div>
  );
}

export function StepNav({ canBack, onBack, onNext, disabled, busy, label = 'Next →' }) {
  return (
    <div className="flex items-center gap-3">
      {canBack && <button onClick={onBack} data-testid="wf-back-btn" className="px-4 py-2 text-slate-500 hover:text-slate-700">← Back</button>}
      <span className="flex-1" />
      <button onClick={() => onNext()} disabled={disabled || busy} data-testid="wf-next-btn"
        className="px-6 py-2 bg-sky-600 text-white font-semibold rounded hover:bg-sky-700 disabled:opacity-40 transition-colors">
        {busy ? 'Saving…' : label}
      </button>
    </div>
  );
}

export function ErrorLine({ err, testid }) {
  if (!err) return null;
  return <div className="p-2 rounded border border-rose-200 bg-rose-50 text-xs text-rose-700" data-testid={testid}>{err}</div>;
}
